import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import emptySiteContent from '../content/fallbackSiteContent';
import { hasContentfulConfig } from '../lib/contentfulClient';

const SiteContentContext = createContext({
  siteContent: emptySiteContent,
  contentStatus: 'idle',
  updateCollection: () => {},
});

export function SiteContentProvider({ children }) {
  const [siteContent, setSiteContent] = useState(emptySiteContent);
  const contentStatus = hasContentfulConfig() ? 'ready' : 'empty';
  const batchRef = useRef(null);

  // Batches collection updates into a single setState per frame
  const updateCollection = useCallback((key, items) => {
    if (!batchRef.current) {
      batchRef.current = {};
      queueMicrotask(() => {
        const updates = batchRef.current;
        batchRef.current = null;
        setSiteContent((current) => {
          const mergedCollections = { ...current.collections };
          Object.entries(updates).forEach(([k, v]) => {
            if (Array.isArray(v) && v.length === 0) return;
            mergedCollections[k] = v;
          });
          // Always preserve fallback proof points
          mergedCollections.proofPoints = emptySiteContent.collections.proofPoints;
          return { ...current, collections: mergedCollections };
        });
      });
    }
    batchRef.current[key] = items;
  }, []);

  return (
    <SiteContentContext.Provider value={{ siteContent, contentStatus, updateCollection }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}
